import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Container, Grid, Tab, Tabs } from '@mui/material';
import SystemMessages from './Messages/SystemMessages';
import PropTypes from 'prop-types';
import OSMessages from './Messages/OSMessages';
import InstitutionalMessages from './Messages/InstitutionalMessages';
import ModalitiesMessages from './Messages/ModalitiesMessages';
import { a11yProps } from '../../utils/utils';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  filtersContainer: {
    marginTop: theme.spacing(1),
  },
  addButtonContainer: {
    height: '100%',
  },
  form: {
    marginTop: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  submitButtonContainer: {
    marginTop: theme.spacing(3),
  },
  sectionTitle: {
    color: '#747474',
  },
  panelLy: {
    width: '100%',
  },
  messages: {
    padding: '32px',
  },
  tabs: {
    paddingLeft: 12,
    alignItems: 'start',
    textAlign: 'start',
    justifyContent: 'flex-start',
    '& .MuiTabs-scrollButtons.Mui-disabled ': {
      display: 'none',
    },
  },
  tab: {
    alignItems: 'start',
  },
}));

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={classes.panelLy}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function Messages() {
  const classes = useStyles();
  const [section, setSection] = useState(0);

  return (
    <div>
      <div className={classes.appBarSpacer} />
      <Container className={classes.messages} maxWidth="lg">
        {true && (
          <>
            <Tabs
              value={section}
              onChange={(_, newValue) => setSection(newValue)}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              className={classes.tabs}
            >
              <Tab className={classes.tab} label="Mensajes de sistema" {...a11yProps(0)} />
              <Tab className={classes.tab} label="Mensajes institucionales" {...a11yProps(1)} />
              <Tab className={classes.tab} label="Mensajes de obras sociales" {...a11yProps(2)} />
              <Tab className={classes.tab} label="Mensajes de modalidades" {...a11yProps(3)} />
            </Tabs>
            <Grid container direction="row" className={classes.filtersContainer}>
              <TabPanel value={section} index={0}>
                <SystemMessages />
              </TabPanel>
              <TabPanel value={section} index={1}>
                <InstitutionalMessages />
              </TabPanel>
              <TabPanel value={section} index={2}>
                <OSMessages />
              </TabPanel>
              <TabPanel value={section} index={3}>
                <ModalitiesMessages />
              </TabPanel>
            </Grid>
          </>
        )}
      </Container>
    </div>
  );
}
